import { render, staticRenderFns } from "./InappropriateFilter.vue?vue&type=template&id=27f01116"
import script from "./InappropriateFilter.vue?vue&type=script&lang=js"
export * from "./InappropriateFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports